/** Shared request bounds: the initial build submits the full concept as its prompt. */
export const BUILD_PROMPT_MAX_LEN = 8000;
export const CONCEPT_MAX_LEN = BUILD_PROMPT_MAX_LEN;
